import React, { FC, memo, CSSProperties, useCallback } from "react";
import { FaBars, FaThLarge } from "react-icons/fa";
import { View } from "@/components/library/ViewModeToggle";

export interface ViewModeToggleProps {
    containerStyle?: CSSProperties;
    selectedView: View;
    setSelectedView: React.Dispatch<React.SetStateAction<View>>;
}

// Detail / compact switch as a small segmented control (as on mobile).
const ViewModeToggle: FC<ViewModeToggleProps> = ({ setSelectedView, selectedView, containerStyle }) => {
    // setSelectedView must be a dependency: a stale handler re-applied old filters on every switch.
    const handlePress = useCallback(
        (view: View) => {
            if (selectedView !== view) setSelectedView(view);
        },
        [selectedView, setSelectedView]
    );

    return (
        <div className="pb-viewtoggle" role="radiogroup" aria-label="View" style={containerStyle}>
            <button
                type="button"
                role="radio"
                aria-checked={selectedView === View.DETAIL}
                aria-label="Detail view"
                title="Detail view"
                className={selectedView === View.DETAIL ? "active" : ""}
                onClick={() => handlePress(View.DETAIL)}
            >
                <FaBars />
            </button>
            <button
                type="button"
                role="radio"
                aria-checked={selectedView === View.COMPACT}
                aria-label="Compact view"
                title="Compact view"
                className={selectedView === View.COMPACT ? "active" : ""}
                onClick={() => handlePress(View.COMPACT)}
            >
                <FaThLarge />
            </button>
        </div>
    );
};

export default memo(ViewModeToggle);
